// extracted by mini-css-extract-plugin
export default {"discountBanner":"Yga","topheader":"Zga","navleft":"aha","navflexelem":"bha","navright":"cha","fixedtop":"eha","abstop":"fha","subdesc":"gha","smallscreennav":"hha","nav_hidden":"iha","cancel_link":"jha","bottomnavcontainer":"kha","fixedbottom":"lha","animatedbottom":"mha","appear-bottom":"nha","delayedbottom":"oha","retakebtn":"pha","long_banner":"qha","nofixed":"rha"};
    if(module.hot) {
      // 1738064244466
      var cssReload = require("../../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  